import { Select as MantineSelect, type SelectProps as MantineSelectProps } from '@mantine/core'
export type SelectProps = MantineSelectProps

export function Select(props: Readonly<SelectProps>) {
  return <MantineSelect {...props} />
}
